function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Head from "/components/core/head";
import { PureComponent } from "react";
import HeaderScriptsComponent from "/components/core/head/header-scripts-component";
import BodyScriptsComponent from "/components/core/body-scripts/body-scripts-component";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { AbTestsContext } from "/contexts/ab-tests-context";
import throttle from "lodash.throttle";
import { trackEvent } from "/services/bigbrain-service";
import { saveCloudfrontViewerCountryCookie } from "services/cookies/cloudfront-viewer-country-cookies-service";
import { getExactEventNameAbTestVariant } from "services/ab-tests/lp-ab-tests-service";
import { getDocumentFullHeight, getPassiveIfSupported, getScrollPercent, getViewportHeight } from "../../services/dom-utils-service";
import { PAGE_SCROLL_BY_PERCENTAGE } from "/constants/bigbrain-event-types";
import { getRandomInt } from "/services/utils-service";
import BypassBlocksMenuComponent from "components/accessibility/bypass-blocks-menu/bypass-block-menu";
import AgentRecoveryLinksComponent from "components/core/agent-recovery-links/agent-recovery-links-component";
import { fireGtmEvent } from "../../client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import PricingVersions from "/constants/pricing-versions";
import { ConditionalWrapper } from "utils/react";
import { PrefetchSignupAssetsProvider } from "client/services/signup/prefetch-signup-service";
import { StyledAccessibilityWrapper, StyledStickyHeaderWrapper, StyledTemplateContentWrapper } from "./base-template.scss";
import { getUrlParamValue, truncateQueryParams } from "utils/url";
import { ROOT_LINK } from "constants/links";
import classnames from "classnames";
import LiveBoardModalComponent from "components/core/live-board-experience/live-board-modal";
import { LIVE_BOARD_CLOSED, LIVE_BOARD_OPENED } from "constants/bigbrain-event-types";
import { PrefetchLiveBoardAssetsProvider } from "client/services/live-board/prefetch-liveboard-service";
import { setCookie } from "/services/cookies-service";
import { setHomepageExactAbTest, clearHomepageExactAbTest } from "services/ab-tests/homepage-exact-ab-test-storage";
import { MULTI_PRODUCTS_TEST_COOKIE_NAME, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME } from "constants/cookies";
import { shouldRenderSecondaryMenu } from "segments/desktop/header/layouts/base-header/base-header-service";
import { StoreUTMDataForEnrichment } from "services/sales-enrichment/sales-enrichment-service";
import { CareersProvider } from "contexts/careers-context";
import ScrollToTop from "segments/desktop/core-components/scroll-to-top/scroll-to-top";
import { DEBUG_AB_TEST_PARAM_NAME } from "constants/new-ab-tests";
import StickyHeader from "segments/desktop/core-components/sticky-header/sticky-header";
import { LoadingProvider } from "contexts/loading-screen-context";
import LoadingOverlayComponent from "../../contexts/supporting-components/loading-overlay/loading-overlay-component";
import { SystemConfigContext } from "contexts/system-config-context";
import StickySignupButtonComponent from "components/core/sticky-signup-button/sticky-signup-button-component";
const SCROLL_PERCENTAGE_THROTTLE_TIME = 1000; // Execute a method only once per THROTTLE_TIME
const SCROLL_PERCENTAGE_STEPS = 10;
const UTM_URL_TERM = "utm";
class BaseTemplate extends PureComponent {
    componentDidMount() {
        var _window_location_href, _window_location, _window;
        const { cloudfrontViewerCountry } = this.props;
        window.addEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
        saveCloudfrontViewerCountryCookie(cloudfrontViewerCountry);
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : (_window_location_href = _window_location.href) === null || _window_location_href === void 0 ? void 0 : _window_location_href.includes(UTM_URL_TERM)) {
            StoreUTMDataForEnrichment();
        }
        this.sendGenericAbTestEventIfNeeded();
        this.setAbTestDebugCookieIfNeeded();
        this.setMultiProductsTestCookieIfNeeded();
        this.setHomepageExactAbTestIfNeeded();
    }
    sendGenericAbTestEventIfNeeded() {
        const { abTestVariants, abTestExactEventName } = this.props;
        const abTestVariant = getExactEventNameAbTestVariant(abTestExactEventName, abTestVariants);
        if (abTestExactEventName && abTestVariant) {
            // TODO: should move to head script (AbTestSplitEventScript) and remove this method. Right now it depended on initialization functions and 3rd party services that should also move to head script
            fireGtmEvent(DataLayerEventTypes.IN_PAGE_AB_TEST_EVENT_NAME, {
                abTestName: abTestExactEventName,
                abTestVariant
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
    }
    render() {
        const { children, title, description, canonicalUrl, asPath, fontLazyLoad, showHeaderScripts, marketingTemplateBoardIds, showTrustpilotReviews, coupon, extendTrialCookie, clusterId, pageProductId, pageClusterId, pageSubClusterId, pageClusterConfig, subClusterId, clusterIdSource, subClusterIdSource, clusterConfig, isClusterMiniSitePage, useProductMiniSiteConfig, localeId, footerCatalogLinks, headerCatalogLinks, userSelectedLanguage, overrideLanguages, withFullstory, fullstoryRecordingFrequency, abTestVariants, abTestExactEventName, template, useExpandingSignup, disableGTM, isMobileOrTabletBrowser, isMobileBrowser, isBAMDisabled, positions, perceptionSurveyTests, imagesLazyLoad, noIndex, noFollow, gtmContainerId, useSectionsMenu, isPreview, currency, cloudfrontViewerCountry, useNewTranslationsApi, useFreeForeverPriceCardKey, enableHotjar, hotjarFinalDate, pricingVersion, hasFreeTier, hideBannerWithBackground, cookies, persistantCookies, lazyImages, grantedFeatures, freeTierForcePrevent, skipClustersQuestion, forcePricing, forceCurrency, hasStudentPlan, facebookMetaOverride, twitterMetaOverride, enablePageUsageDurationTracking, activePagePath, activeOriginalPagePath, localizedPages, pageBackgroundColorName, is404Page, isPricingPage, sendToSignupWithProductPage, seoFAQ, addLiveBoardExperience, preloadFirstFoldImages, shouldGetSignupPrefetchedAssets, signupDynamicAssetsLinks, embeddedBoardLink, forceProductSignup, customHeadScript, customBodyScript, jsonLdSchema, segments, isInContactSalesNoHeaderTest, simulateGetQuoteAndScrollToForm, contactSalesProductParam, excludeFromSignupTests, showScrollToTop, withStickyHeader, simulatePostSubmissionCXTest, simulateSmallCompanySize, useAdaBotInPage, stickySignupButton, triggerChatDelay, simulateCampaignProductHomepageFirstFoldTest, simulateCampaignProductSignupTest, crossOriginLocaleAbTest, simulateOneTapGoogleSignupCRM, simulateEnterpriseToUltimateRenameTest, simulateNewPricingTest, enableCreditsPricing, enableUpdatedCreditsPricingCards, simulateCrmPricingIncreaseTest, simulateCreditsPerSeatTest, webflowPageLocaleQueryParam, randomEvenOrOdd, customSignupFlow, isNewBrand } = this.props;
        const { showLiveBoard, showLiveBoardImage, liveBoardClosed, liveBoardProps, startShowingStickyHeader } = this.state;
        const isSecondaryMenuNeeded = shouldRenderSecondaryMenu(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig);
        function extractTypes(data) {
            return data === null || data === void 0 ? void 0 : data.map((item)=>item.type);
        }
        return /*#__PURE__*/ _jsx(SystemConfigContext.Provider, {
            value: {
                isBAMDisabled
            },
            children: /*#__PURE__*/ _jsx(GenericConfigContext.Provider, {
                value: {
                    localeId,
                    footerCatalogLinks,
                    headerCatalogLinks,
                    clusterId,
                    pageProductId,
                    pageClusterId,
                    pageSubClusterId,
                    pageClusterConfig,
                    subClusterId,
                    clusterConfig,
                    isClusterMiniSitePage,
                    useProductMiniSiteConfig,
                    userSelectedLanguage,
                    overrideLanguages,
                    useExpandingSignup,
                    isMobileOrTabletBrowser,
                    isMobileBrowser,
                    imagesLazyLoad,
                    noIndex,
                    noFollow,
                    isPreview,
                    hasFreeTier,
                    positions,
                    perceptionSurveyTests,
                    pricingVersion: isPreview ? PricingVersions.DEFAULT_VERSION : pricingVersion,
                    cloudfrontViewerCountry,
                    useNewTranslationsApi,
                    useFreeForeverPriceCardKey,
                    lazyImages,
                    translate: this.translate,
                    translateWithParam: this.translateWithParam,
                    translateOrTranslateWithParam: this.translateOrTranslateWithParam,
                    hideBannerWithBackground,
                    cookies,
                    persistantCookies,
                    currency,
                    grantedFeatures,
                    freeTierForcePrevent,
                    forcePricing,
                    forceCurrency,
                    hasStudentPlan,
                    activePagePath,
                    activeOriginalPagePath,
                    useSectionsMenu,
                    is404Page,
                    isPricingPage,
                    sendToSignupWithProductPage,
                    isSecondaryMenuNeeded,
                    addLiveBoardExperience,
                    openLiveBoard: this.openLiveBoard,
                    showLiveBoardImage,
                    liveBoardClosed,
                    forceProductSignup,
                    setIsFirstFoldVisible: this.setIsFirstFoldVisible,
                    setStartShowingStickyHeader: this.setStartShowingStickyHeader,
                    isInContactSalesNoHeaderTest,
                    simulateGetQuoteAndScrollToForm,
                    contactSalesProductParam,
                    excludeFromSignupTests,
                    simulatePostSubmissionCXTest,
                    simulateSmallCompanySize,
                    simulateCampaignProductHomepageFirstFoldTest,
                    simulateCampaignProductSignupTest,
                    simulateOneTapGoogleSignupCRM,
                    simulateEnterpriseToUltimateRenameTest,
                    enableCreditsPricing,
                    enableUpdatedCreditsPricingCards,
                    simulateCrmPricingIncreaseTest,
                    simulateCreditsPerSeatTest,
                    simulateNewPricingTest,
                    asPath,
                    webflowPageLocaleQueryParam,
                    randomEvenOrOdd,
                    customSignupFlow,
                    isNewBrand
                },
                children: /*#__PURE__*/ _jsxs(LoadingProvider, {
                    children: [
                        /*#__PURE__*/ _jsx(LoadingOverlayComponent, {}),
                        /*#__PURE__*/ _jsx(AbTestsContext.Provider, {
                            value: {
                                abTestVariants,
                                abTestExactEventName,
                                crossOriginLocaleAbTest
                            },
                            children: /*#__PURE__*/ _jsx(CareersProvider, {
                                children: /*#__PURE__*/ _jsx(ConditionalWrapper, {
                                    condition: shouldGetSignupPrefetchedAssets,
                                    wrapper: (children)=>/*#__PURE__*/ _jsx(PrefetchSignupAssetsProvider, {
                                            signupDynamicAssetsLinks: signupDynamicAssetsLinks,
                                            children: children
                                        }),
                                    children: /*#__PURE__*/ _jsx(ConditionalWrapper, {
                                        condition: addLiveBoardExperience,
                                        wrapper: (children)=>/*#__PURE__*/ _jsx(PrefetchLiveBoardAssetsProvider, {
                                                children: children
                                            }),
                                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Head, {
                                                    title: title,
                                                    description: description,
                                                    canonicalUrl: canonicalUrl,
                                                    seoFAQ: seoFAQ,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    pagePath: asPath,
                                                    facebookMetaOverride: facebookMetaOverride,
                                                    twitterMetaOverride: twitterMetaOverride,
                                                    localizedPages: localizedPages,
                                                    shouldGetSignupPrefetchedAssets: shouldGetSignupPrefetchedAssets,
                                                    addLiveBoardExperience: addLiveBoardExperience,
                                                    preloadFirstFoldImages: preloadFirstFoldImages,
                                                    jsonLdSchema: jsonLdSchema
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ _jsx(HeaderScriptsComponent, {
                                                    coupon: coupon,
                                                    extendTrialCookie: extendTrialCookie,
                                                    marketingTemplateBoardIds: marketingTemplateBoardIds,
                                                    clusterId: clusterId,
                                                    subClusterId: subClusterId,
                                                    clusterIdSource: clusterIdSource,
                                                    subClusterIdSource: subClusterIdSource,
                                                    localeId: localeId,
                                                    template: template,
                                                    skipClustersQuestion: skipClustersQuestion,
                                                    enablePageUsageDurationTracking: enablePageUsageDurationTracking,
                                                    customHeadScript: customHeadScript,
                                                    segmentsList: extractTypes(segments)
                                                }),
                                                showScrollToTop && /*#__PURE__*/ _jsx(ScrollToTop, {}),
                                                !isPreview && /*#__PURE__*/ _jsx(StyledAccessibilityWrapper, {
                                                    className: "accessibility-menu-wrapper",
                                                    children: /*#__PURE__*/ _jsx(BypassBlocksMenuComponent, {})
                                                }),
                                                /*#__PURE__*/ _jsxs(StyledTemplateContentWrapper, {
                                                    className: classnames("template-content-wrapper", {
                                                        "with-background-color": !!pageBackgroundColorName
                                                    }),
                                                    children: [
                                                        children,
                                                        is404Page && /*#__PURE__*/ _jsx(AgentRecoveryLinksComponent, {}),
                                                        addLiveBoardExperience && /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "live-board-popup-wrapper",
                                                                children: /*#__PURE__*/ _jsx(LiveBoardModalComponent, _object_spread({
                                                                    showLiveBoard: showLiveBoard,
                                                                    closeLiveBoard: this.closeLiveBoard,
                                                                    translate: this.translate,
                                                                    openPeekToBoard: this.openPeekToBoard,
                                                                    closePeekToBoard: this.closePeekToBoard,
                                                                    embeddedBoardLink: embeddedBoardLink
                                                                }, liveBoardProps))
                                                            })
                                                        }),
                                                        withStickyHeader && /*#__PURE__*/ _jsx(StyledStickyHeaderWrapper, {
                                                            className: classnames("sticky-header", {
                                                                "show-sticky-header": startShowingStickyHeader
                                                            }),
                                                            children: /*#__PURE__*/ _jsx(StickyHeader, {
                                                                startShowingStickyHeader: startShowingStickyHeader
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (stickySignupButton === null || stickySignupButton === void 0 ? void 0 : stickySignupButton.enabled) === "true" && /*#__PURE__*/ _jsx(StickySignupButtonComponent, {
                                                    scrollThreshold: stickySignupButton === null || stickySignupButton === void 0 ? void 0 : stickySignupButton.scrollThreshold
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ _jsx(BodyScriptsComponent, {
                                                    withFullstory: withFullstory,
                                                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                                                    showTrustpilotReviews: showTrustpilotReviews,
                                                    pagePath: asPath,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    enableHotjar: enableHotjar,
                                                    hotjarFinalDate: hotjarFinalDate,
                                                    clusterId: clusterId,
                                                    hasFreeTier: hasFreeTier,
                                                    localeId: localeId,
                                                    subClusterId: subClusterId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    is404Page: is404Page,
                                                    customBodyScript: customBodyScript,
                                                    useAdaBot: useAdaBotInPage,
                                                    triggerChatDelay: triggerChatDelay
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "openLiveBoard", (props)=>{
            this.setState({
                showLiveBoard: true,
                showLiveBoardImage: false,
                liveBoardProps: props
            });
            trackEvent(LIVE_BOARD_OPENED);
        });
        _define_property(this, "setIsFirstFoldVisible", (state)=>{
            this.setState({
                isFirstFoldVisible: state
            });
        });
        _define_property(this, "setStartShowingStickyHeader", (state)=>{
            this.setState({
                startShowingStickyHeader: state
            });
        });
        _define_property(this, "closeLiveBoard", ()=>{
            this.setState({
                showLiveBoard: false,
                showLiveBoardImage: true,
                liveBoardClosed: true
            });
            trackEvent(LIVE_BOARD_CLOSED);
        });
        var _this = this;
        _define_property(this, "scrollingByPercentage", /*#__PURE__*/ _async_to_generator(function*() {
            const { maxRecordedScrollPercentage } = _this.state;
            try {
                const currentScrollPercentage = yield getScrollPercent();
                const documentHeight = yield getDocumentFullHeight();
                const viewportHeight = yield getViewportHeight();
                if (currentScrollPercentage > maxRecordedScrollPercentage + SCROLL_PERCENTAGE_STEPS) {
                    _this.setState({
                        maxRecordedScrollPercentage: currentScrollPercentage
                    });
                    trackEvent(PAGE_SCROLL_BY_PERCENTAGE, {
                        kind: parseInt(currentScrollPercentage),
                        info1: viewportHeight,
                        info2: documentHeight,
                        info3: _this.pageLoadUnique //	for easily find the last event per page load
                    });
                }
            } catch (e) {}
        }));
        _define_property(this, "setAbTestDebugCookieIfNeeded", ()=>{
            const { asPath } = this.props;
            const abTestDebugParamValue = getUrlParamValue(asPath, DEBUG_AB_TEST_PARAM_NAME);
            if (abTestDebugParamValue) {
                setCookie(WEBSITE_AB_TEST_DEBUG_COOKIE_NAME, abTestDebugParamValue, {
                    expires: 1 / 24 // 1 hour
                });
            }
        });
        _define_property(this, "setMultiProductsTestCookieIfNeeded", ()=>{
            const { abTestVariants, perceptionSurveyTests } = this.props;
            const perceptionSurveyTestsNames = perceptionSurveyTests === null || perceptionSurveyTests === void 0 ? void 0 : perceptionSurveyTests.map((test)=>test.testName);
            const multiProductsTest = abTestVariants === null || abTestVariants === void 0 ? void 0 : abTestVariants.find((abTest)=>perceptionSurveyTestsNames === null || perceptionSurveyTestsNames === void 0 ? void 0 : perceptionSurveyTestsNames.includes(abTest.name));
            if (multiProductsTest) {
                setCookie(MULTI_PRODUCTS_TEST_COOKIE_NAME, JSON.stringify({
                    id: multiProductsTest.id,
                    variant: multiProductsTest.versionNum
                }), {
                    expires: 1 // 24 hours
                });
            }
        });
        _define_property(this, "setHomepageExactAbTestIfNeeded", ()=>{
            const { asPath, abTestVariants, abTestExactEventName } = this.props;
            if (truncateQueryParams(asPath) !== ROOT_LINK) return;
            const exactTest = abTestVariants === null || abTestVariants === void 0 ? void 0 : abTestVariants.find((abTest)=>abTest.name === abTestExactEventName);
            if (exactTest === null || exactTest === void 0 ? void 0 : exactTest.variant) {
                setHomepageExactAbTest(exactTest.variant);
            } else {
                clearHomepageExactAbTest();
            }
        });
        _define_property(this, "translate", (key)=>{
            const { translations } = this.props;
            return translations[key] || key;
        });
        _define_property(this, "translateWithParam", (key, parameter1)=>{
            const translation = this.translate(key);
            const templateString = translation.replace("%param1%", parameter1);
            return templateString;
        });
        _define_property(this, "translateOrTranslateWithParam", (keyToTranslate)=>{
            if (!keyToTranslate) return null;
            if (typeof keyToTranslate === "object") {
                const { key, param } = keyToTranslate;
                return this.translateWithParam(key, param);
            }
            return this.translate(keyToTranslate);
        });
        this.pageLoadUnique = getRandomInt(100000000);
        this.passiveIfSupported = getPassiveIfSupported();
        this.scrollPercentageEvent = throttle(this.scrollingByPercentage, SCROLL_PERCENTAGE_THROTTLE_TIME, {
            leading: false,
            trailing: true
        });
        this.state = {
            maxRecordedScrollPercentage: 0,
            showLiveBoard: false,
            showLiveBoardImage: true,
            isFirstFoldVisible: true,
            startShowingStickyHeader: false,
            liveBoardClosed: false,
            liveBoardProps: {}
        };
    }
}
export { BaseTemplate as default };
BaseTemplate.defaultProps = {
    showHeaderScripts: true,
    withFullstory: false,
    useExpandingSignup: false,
    translations: {},
    isPreview: false,
    skipClustersQuestion: false
};
